var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CategoriesApiService } from '@ClientApi/categories';
export const ADD_CATEGORIES = 'ADD_CATEGORIES';
export const SET_CATEGORIES_LOADING = 'SET_CATEGORIES_LOADING';
export const CATEGORIES_ADD_CATEGORIES_FOR_USER = 'CATEGORIES_ADD_CATEGORIES_FOR_USER';
export class AddCategories {
    constructor(categories) {
        this.categories = categories;
        this.type = ADD_CATEGORIES;
    }
}
export class SetCategoriesLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_CATEGORIES_LOADING;
    }
}
export class AddCategoriesForUser {
    constructor(userId, categories) {
        this.type = CATEGORIES_ADD_CATEGORIES_FOR_USER;
        this.payload = { userId, categories };
    }
}
export const getCategories = (dispatch) => (params = {}) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetCategoriesLoading(true));
    const categories = yield CategoriesApiService.getCategories(params);
    dispatch(new AddCategories(categories));
    dispatch(new SetCategoriesLoading(false));
    return categories;
});
